import React from 'react';
import { Code2, Database, Globe } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const About = () => {
  const [titleRef, titleVisible] = useScrollAnimation(0.2);
  const [contentRef, contentVisible] = useScrollAnimation(0.1);

  return (
    <section className="py-24 px-4 md:px-8 relative">
      <div className="max-w-6xl mx-auto">
        <h2
          ref={titleRef}
          className={`text-5xl md:text-6xl font-bold mb-16 text-center scroll-animate ${titleVisible ? 'visible' : ''}`}
        >
          <span className="bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent">
            About Me
          </span>
        </h2>

        <div
          ref={contentRef}
          className={`grid md:grid-cols-2 gap-12 items-center scroll-animate ${contentVisible ? 'visible' : ''}`}
        >
          {/* Text Content */}
          <div className="space-y-6">
            <p className="text-zinc-300 text-lg leading-relaxed">
              Hey there! I'm a fullstack web developer who loves bringing ideas
              to life through code. Whether it's building custom content
              management systems or creating admin panels for local businesses,
              I enjoy tackling challenges and finding elegant solutions.
            </p>

            <p className="text-zinc-300 text-lg leading-relaxed">
              My journey started with managing a media and photography business
              for 3 years, which taught me a lot about working with clients and
              understanding their needs. For the past year, I've been focused on
              developing software solutions for small businesses. I work with
              React, NextJS, and ASP .NET Core, and I'm comfortable with various
              databases like MongoDB, MySQL, and SQL Server. I have also
              recently started my journey into learning more about the
              fundamentals of Cybersecurity with the aim of aquiring my first
              certification in the near future.
            </p>

            <p className="text-zinc-300 text-lg leading-relaxed">
              I'm always curious about new technologies and love learning new
              things. When I'm not coding, I enjoy solving problems and
              connecting with people. I also gained valuable experience as a
              customer support intern at an Internet Service Provider, which
              really sharpened my communication skills.
            </p>

            {/* Skills highlights */}
            <div className="grid grid-cols-3 gap-4 pt-6">
              <div className="text-center p-4 rounded-xl bg-zinc-900/40 backdrop-blur-sm border border-zinc-800">
                <Code2 className="w-8 h-8 mx-auto mb-2 text-purple-400" />
                <p className="text-sm text-zinc-400">Web Dev</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-zinc-900/40 backdrop-blur-sm border border-zinc-800">
                <Database className="w-8 h-8 mx-auto mb-2 text-cyan-400" />
                <p className="text-sm text-zinc-400">Databases</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-zinc-900/40 backdrop-blur-sm border border-zinc-800">
                <Globe className="w-8 h-8 mx-auto mb-2 text-purple-400" />
                <p className="text-sm text-zinc-400">Full Stack</p>
              </div>
            </div>
          </div>

          {/* Image Placeholder */}
          <div className="flex justify-center">
            <div className="relative w-full max-w-md aspect-square">
              {/* Decorative elements */}
              <div className="absolute -inset-4 bg-gradient-to-br from-purple-600/20 to-cyan-500/20 rounded-3xl blur-2xl"></div>

              {/* Image container */}
              <div className="relative w-full h-full rounded-3xl overflow-hidden bg-zinc-900/40 backdrop-blur-sm border border-zinc-800">
                <div className="w-full h-full bg-gradient-to-br from-zinc-800 to-zinc-900 flex items-center justify-center">
                  <div className="text-center">
                    <img
                      className="w-[80%] h-[80%] mx-auto mb-4 rounded-full bg-gradient-to-br from-purple-600 to-cyan-500 flex items-center justify-center"
                      src="/headshot-2.jpg"
                    />

                    <p className="text-zinc-500 text-sm">Warren Jonas</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
